import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import checkoutApi, { GetTiersResponse } from '../../../api/checkout/checkoutApi';
import { CheckoutState } from './checkoutSlice';

/**
 * Loads pricing tiers for the checkout modal
 */
export const fetchTiersThunk = createAsyncThunk('/checkout/fetch/tiers', async (): Promise<GetTiersResponse> => {
	const response = await checkoutApi.getTiers();
	return response;
});

/**
 * Reducer mapping for fetchTiersThunk lifecycle
 */
export const fetchTiersReducer = (builder: ActionReducerMapBuilder<CheckoutState>): void => {
	builder.addCase(fetchTiersThunk.pending, (state) => {
		state.loading = true;
		state.error = undefined;
	});

	builder.addCase(fetchTiersThunk.rejected, (state, action) => {
		state.loading = false;
		state.error = action.error.message || 'Failed to load tiers';
	});

	builder.addCase(fetchTiersThunk.fulfilled, (state, action) => {
		state.loading = false;
		state.tiers = action.payload.tiers;
	});
};


